/* eslint-disable import/prefer-default-export */
export const getOrderedLenders = (lenders) => {
  const lendersOrder = ['cas', 'sallie-mae', 'citizens-bank', 'mefa']
  return lenders.length
    ? lendersOrder.reduce((acc, curr) => {
        const lender = lenders.find(({ slug }) => slug === curr)

        return lender ? [...acc, lender] : acc
      }, [])
    : []
}
